export default "__VITE_ASSET__BZH4fv1d__"